import { Link, useParams } from "react-router-dom";
import moment from "moment";

export const AuthorListItem = ({item})=>{
	const {school} = useParams();
	return (
		<div key={item.id} className={`meeting ${item.expire?'expire':''} ${item.bestName!==null?'best':''} `}>
			<Link to={`/${school}/meeting?id=${item.id}`}>
				<div className="video_thumb">
					<img className="image" src={item.book.image} alt="" />
					{ item.bestName && 
						<img className="meeting_king" src={`${process.env.PUBLIC_URL}/images/contents/meeting/meetingListBest.png`} alt="질문왕 선정" />
					}
				</div>
				<div className="book_info">
					{ !item.expire && 
						<p className="date">
							질문기간: {moment(item.stdate).format('yyyy.MM.DD.')}~{moment(item.eddate).format('MM.DD.')}까지
						</p>
					}
					{ item.bestName &&
						<>
							<p className="title">{item.bestName} <small>{item.bestGrade}학년</small></p>
							<p className="info"><span>{item.bestSchoolCityName} {item.bestSchoolName}</span></p>
						</>
					}
					
					{ !item.bestName &&
						<>
							<p className="title">{item.book.title}</p>
							<p className="info"><span>{item.book.author}</span><span>{item.book.publisher}</span></p>
						</>
					}
				</div>
			</Link>
		</div>
	);
};